import { EditBase } from "../shared/edit.base";
import { Component, Inject } from "@angular/core";
import { CVCompetenceGroupsService } from "../../core/cvcompetencegroups.dataservice";
import { StateService, TransitionService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";

@Component({
    selector: "crew-edit-cvcompetencegroup",
    template: require('../shared/edit-view.html')
})
export class EditCVCompetenceGroup extends EditBase<Nema.Crew.Model.CVCompetenceGroup> {

    constructor(
        stateService: StateService,
        transitionService: TransitionService,
        dialog: MatDialog,
        @Inject('cvcompetencegroup') entity: Nema.Crew.Model.CVCompetenceGroup,
        @Inject('cvCompetenceGroupsService') cvcompetencegroupDataService: CVCompetenceGroupsService,
        @Inject('$log') $log: ng.ILogService,
        @Inject('isNew') isNew: boolean) {

        super(stateService, transitionService, dialog, entity, cvcompetencegroupDataService, $log, isNew);
    }

    public entityDisplayName = "CV Competence Group";

    public listStateName = "app.settings.cvcompetencegroups";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/cvcompetencegroups/cvcompetencegroup.edit.component.ts